import { Number, Record, Static } from "runtypes";

export const SchoolIdRequestRuntype = Record({
  schoolId: Number,
});

export interface ISchoolIdRequest
  extends Static<typeof SchoolIdRequestRuntype> {}



// WEBPACK FOOTER //
// ./src/api/types/ISchoolIdRequest.ts